import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { useOnMount } from '../../../../common/hooks/useOnMount';
import { ConfirmationModal } from '../../../components/ConfirmationModal';
import { useLoader } from '../../../helpers/useLoader';
import { IntegrationsList } from '../components/integrationsList';
import { IIntegrationsService } from '../integrations.service';

export const IntegrationsListContainer = observer((): ReactElement => {
  const integrationsService = useInjection(IIntegrationsService.$);

  const { isLoading, withLoaderAsync } = useLoader();
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [apiKeyId, setApiKeyId] = useState<string | undefined>(undefined);

  const handleDeleteApiKey = async (): Promise<void> => {
    await withLoaderAsync(async () => {
      if (apiKeyId !== undefined) {
        await integrationsService.deleteApiKey(apiKeyId);
      }
      hideModal();
    });
  };

  const hideModal = (): void => {
    setIsDeleteModalShow(false);
  };

  const showModal = (apiKeyId: string): void => {
    setApiKeyId(apiKeyId);
    setIsDeleteModalShow(true);
  };

  useOnMount(async () => {
    await withLoaderAsync(async () => integrationsService.loadApiKeys());
  });

  return (
    <>
      <IntegrationsList
        apiKeys={integrationsService.store.apiKeys}
        isLoading={isLoading}
        onDeleteApiKey={showModal}
      />
      <ConfirmationModal
        showModal={isDeleteModalShow}
        confirmationHeader={'delete_confirmation_api_key_header'}
        confirmationQuestion={'delete_confirmation_api_key_message'}
        onCancel={hideModal}
        onConfirm={handleDeleteApiKey}
        confirmationYes={'delete'}
      />
    </>
  );
});
